import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Ending from "./pages/Ending";
import ScreenQuestion from "./pages/ScreenQuestion";
import Success from "./pages/Success";
import ProfilerQuesion from "./pages/ProfilerQuesion";
import Error from "./pages/Error";
import Start from "./pages/Start";
import {
  LANDING_ROUTE,
  SCREENER_ROUTE,
  PROFILING_ROUTE,
  START_ROUTE,
  SUCCESS_ROUTE,
  ENDING_ROUTE,
  ERROR_ROUTE,
  TERMINATE,
  SECURITY_TERMINATE,
  OVER_QUOTA,
  CAMPAIGN_ROUTE,
} from "./constants/routes.constants";
import Terminate from "./pages/Terminate";
import OverQuota from "./pages/OverQuota";
import SecurityTerminate from "./pages/SecurityTerminate";
import Landing from "./pages/Landing";
import Campaign from "./pages/Campaign";
import BrowserCloseHandler from "./pages/BrowserHandler";
import SuccessV2 from "./pages/SuccessV2";
import TerminateV2 from "./pages/TerminateV2";
import OverQuotaV2 from "./pages/OverQuotaV2";
import SecurityTerminateV2 from "./pages/SecurityTerminateV2";
import {
  SUCCESS_ROUTE_V2,
  TERMINATE_V2,
  OVER_QUOTA_V2,
  SECURITY_TERMINATE_V2,
} from "./constants/routes.constants";

function App() {
  return (
    <div className="App h-screen ">
      <BrowserCloseHandler/>
      <BrowserRouter>
        <Routes>
          <Route path={LANDING_ROUTE} element={<Landing />} />
          <Route path={CAMPAIGN_ROUTE} element={<Campaign />} />
          <Route path={SCREENER_ROUTE} element={<ScreenQuestion />} />
          <Route path={PROFILING_ROUTE} element={<ProfilerQuesion />} />

          {/* start */}
          <Route path={START_ROUTE} element={<Start />} />
          <Route path={SUCCESS_ROUTE} element={<Success />} />
          <Route path={ENDING_ROUTE} element={<Ending />} />
          <Route path={ERROR_ROUTE} element={<Error />} />
          <Route path={TERMINATE} element={<Terminate />} />
          <Route path={OVER_QUOTA} element={<OverQuota />} />
          <Route path={SECURITY_TERMINATE} element={<SecurityTerminate />} />

          {/* New wow-factor ending pages (token + API driven) — additive, do not replace the routes above */}
          <Route path={SUCCESS_ROUTE_V2} element={<SuccessV2 />} />
          <Route path={TERMINATE_V2} element={<TerminateV2 />} />
          <Route path={OVER_QUOTA_V2} element={<OverQuotaV2 />} />
          <Route path={SECURITY_TERMINATE_V2} element={<SecurityTerminateV2 />} />

          <Route path="*" element={<Navigate to={ERROR_ROUTE} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
